<template>
<div class="industrycontents">
  <div class="contents ">
    <goods-class-title :src="require('@/assets/images/industrybanner.png')" :imgwidth="496" :marginbottom="40"/>
    <div class="industry-list">
      <goods-industry-item v-for="(industry,index) in industrylist" :key="index" v-if="index%3==0" :industry="industry" :index="(index+1)%3" />
    </div>

    <div class="industry-list">
      <goods-industry-item v-for="(industry,index) in industrylist" :key="index" v-if="index%3==1" :industry="industry" :index="(index+1)%3" />
    </div>

    <div class="industry-list">
      <goods-industry-item v-for="(industry,index) in industrylist" :key="index" v-if="index%3==2" :industry="industry" :index="(index+1)%3" />
    </div>
    

  </div>
  </div>
</template>

<script>
import GoodsIndustryItem from './GoodsIndustryItem.vue'
import GoodsClassTitle from './GoodsClassTitle.vue'
export default {
  data(){
      return{
          industrylist:{}
      }
  },
  components: { GoodsClassTitle, GoodsIndustryItem },
  methods:{
      getlist(){
        //获取行业列表
        const res = this.$api.index.getIndustrys();
        this.industrylist = res.data.list
      }
  },
  mounted(){
      this.getlist();
  }  
}
</script>

<style  scoped>
  .industrycontents{
    background: url("/static/brandbackground.png") no-repeat;
    background-size: 100% auto;
    overflow: hidden;
  }
  .industry-list{
    float: left;
    width: 390px;
    margin-right: 15px;
  }
  .industry-list:last-child{
    margin-right: 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/index/GoodsIndustry.vue